/** Parse `/crew/:id` route params — only accept positive integers (avoids NaN API calls). */
export function parseCrewRouteId(id: string | undefined | null): number | undefined {
  if (id == null || id === '') return undefined;
  if (!/^\d+$/.test(id)) return undefined;
  const n = Number(id);
  return Number.isFinite(n) && n > 0 ? n : undefined;
}

export function isValidCrewId(id: number | undefined | null): id is number {
  return typeof id === 'number' && Number.isFinite(id) && id > 0;
}
